import { call, put, select, takeLatest } from "redux-saga/effects";
import jwtManager from "src/utils/jwtManager";
import { analysisCreateFailure, analysisCreateRequest, analysisCreateSuccess, analysisDatasetFailure, analysisDatasetRequest, analysisDatasetSuccess, analysisDetailsFailure, analysisDetailsRequest, analysisDetailsSuccess, analysisListFailure, analysisListRequest, analysisListSuccess, analysisModelSelectionFailure, analysisModelSelectionRequest, analysisModelSelectionSuccess, analysisUpdateFailure, analysisUpdateRequest, analysisUpdateSuccess, dwtAnalysisFailure, dwtAnalysisRequest, dwtAnalysisSuccess, dwtTransformFailure, dwtTransformRequest, dwtTransformSuccess, favoriteModelsFailure, favoriteModelsRequest, favoriteModelsSuccess, modelEvaluationFailure, modelEvaluationRequest, modelEvaluationSuccess, operationConfigsFailure, operationConfigsRequest, operationConfigsSuccess, operationCreateFailure, operationCreateRequest, operationCreateSuccess, operationDatasetAddFailure, operationDatasetAddRequest, operationDatasetAddSuccess, operationDetailsFailure, operationDetailsRequest, operationDetailsSuccess, operationListFailure, operationListRequest, operationListSuccess, selectedModelsFailure, selectedModelsRequest, selectedModelsSuccess, trainingFailure, trainingRequest, trainingResultsFailure, trainingResultsRequest, trainingResultsSuccess, trainingSuccess } from "../actions/operations";
import { analysisCreateApi, analysisDatasetApi, analysisDetailsApi, analysisListApi, analysisModelSelectionApi, analysisUpdateApi, dwtAnalysisApi, dwtTransformApi, favoriteModelsApi, modelEvaluationApi, operationConfigsApi, operationCreateApi, operationDatasetAddApi, operationDetailsApi, operationListApi, selectedModelsApi, trainingApi, trainingResultsApi } from "src/services/operations";
import { Samples } from '../../mocks/db';
import { history } from "src";
import { pushSamples } from "src/components/AIEngine/Operations/Datasets";

function* operationConfigsSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state);
    const headers = { ...defaultHeaders, token: jwtManager.getToken() };

    const response = yield call(operationConfigsApi, null, headers);
    const {
      data: {
        result: { message, status, data },
      },
    } = response;

    if (status === "Success") {
      yield put(operationConfigsSuccess({ data }));
    } else {
      yield put(operationConfigsFailure(message));
    }
  } catch (error) {
    yield put(operationConfigsFailure(error));
  }
}

function* operationListSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state);
    const headers = { ...defaultHeaders, token: jwtManager.getToken() };

    const response = yield call(operationListApi, null, headers);
    const {
      data: {
        result: { message, status, data },
      },
    } = response;

    if (status === "Success") {
      yield put(operationListSuccess({ data }));
    } else {
      yield put(operationListFailure(message));
    }
  } catch (error) {
    yield put(operationListFailure(error));
  }
}

function* analysisListSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state);
    const headers = { ...defaultHeaders, token: jwtManager.getToken() };

    const response = yield call(analysisListApi(action.payload), null, headers);
    const {
      data: {
        result: { message, status, data },
      },
    } = response;

    if (status === "Success") {
      yield put(analysisListSuccess({ data }));
    } else {
      yield put(analysisListFailure(message));
    }
  } catch (error) {
    yield put(analysisListFailure(error));
  }
}

function* analysisCreateSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const params = action.payload;
    const response = yield call(analysisCreateApi, params, headers);
    const {
      data: {
        result: { message, status, data },
      },
    } = response

    if (status === "Success") {
      yield put(analysisCreateSuccess({ data }));
      yield put(analysisListRequest(params.opid));
    } else {
      yield put(analysisCreateFailure(message));
    }
  } catch (error) {
    yield put(analysisCreateFailure(error));
  }
}

function* operationDatasetAddSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const params = action.payload;
    const samples = params?.dataset_entry?.dataset?.samples
    const response = yield call(operationDatasetAddApi, params, headers);
    const {
      data: {
        result: { message, status, data },
      },
    } = response

    if (status === "Success") {
      yield put(operationDatasetAddSuccess({ data }));
      yield put(operationDetailsRequest({ opid: params.opid }));
      Samples.insertMany(samples);
      for (const sample of samples) pushSamples([sample])
    } else {
      yield put(operationDatasetAddFailure(message));
    }
  } catch (error) {
    yield put(operationDatasetAddFailure(error));
  }
}

function* analysisDatasetSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const params = action.payload;
    const response = yield call(analysisDatasetApi(params), null, headers);
    const {
      data: {
        result: { message, status, data },
      },
    } = response

    if (status === "Success") {
      yield put(analysisDatasetSuccess({ data }));
    } else {
      yield put(analysisDatasetFailure(message));
    }
  } catch (error) {
    yield put(analysisDatasetFailure(error));
  }
}

function* operationCreateSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const params = action.payload;
    const response = yield call(operationCreateApi, params, headers);
    const {
      data: {
        result: { message, status, data },
      },
    } = response

    if (status === "Success") {
      yield put(operationCreateSuccess({ data }));
      history.push(`/ai-engine/operations/${data.id}/details`)
    } else {
      yield put(operationCreateFailure(message));
    }
  } catch (error) {
    yield put(operationCreateFailure(error));
  }
}

function* operationDetailsSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const opid = action.payload.opid;
    const response = yield call(operationDetailsApi(opid), null, headers);
    const {
      data: {
        result: { message, status, data },
      },
    } = response

    if (status === "Success") {
      yield put(operationDetailsSuccess({ data }));
    } else {
      yield put(operationDetailsFailure(message));
    }
  } catch (error) {
    yield put(operationDetailsFailure(error));
  }
}

function* analysisDetailsSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const anid = action.payload;
    const response = yield call(analysisDetailsApi(anid), null, headers);
    const {
      data: {
        result: { message, status, data },
      },
    } = response

    if (status === "Success") {
      yield put(analysisDetailsSuccess({ data }));
    } else {
      yield put(analysisDetailsFailure(message));
    }
  } catch (error) {
    yield put(analysisDetailsFailure(error));
  }
}

function* analysisUpdateSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const anid = action.payload;
    const response = yield call(analysisUpdateApi, anid, headers);
    const {
      data: {
        result: { message, status, data },
      },
    } = response

    if (status === "Success") {
      yield put(analysisUpdateSuccess({ data }));
    } else {
      yield put(analysisUpdateFailure(message));
    }
  } catch (error) {
    yield put(analysisUpdateFailure(error));
  }
}

function* dwtAnalysisSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const dataset = action.payload;
    const response = yield call(dwtAnalysisApi, dataset, headers);
    const {
      data,
      status
    } = response

    if (status === 200) {
      yield put(dwtAnalysisSuccess({ data }));
    } else {
      yield put(dwtAnalysisFailure("Failed to analyze."));
    }
  } catch (error) {
    yield put(dwtAnalysisFailure(error));
  }
}

function* dwtTransformSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const params = action.payload;
    const response = yield call(dwtTransformApi, params, headers);
    const {
      data,
      status
    } = response

    if (status === 200) {
      yield put(dwtTransformSuccess({ data }));
    } else {
      yield put(dwtTransformFailure("Failed to transform."));
    }
  } catch (error) {
    yield put(dwtTransformFailure(error));
  }
}

function* trainingSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const params: any = action.payload;
    const response = yield call(trainingApi, params, headers);
    const {
      data,
      status
    } = response

    if (status === 200) {
      yield put(trainingSuccess({ data }));
      history.push(`/ai-engine/operations/${params.opid}/analysis/${params.anid}/selection`, { loading: true })
    } else {
      yield put(trainingFailure(data?.message));
    }
  } catch (error) {
    yield put(trainingFailure(error));
  }
}

function* trainingResultsSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const anid = action.payload;
    const response = yield call(trainingResultsApi(anid), null, headers);
    const {
      data: {
        result: { status, data },
      },
    } = response

    if (status === "Success") {
      yield put(trainingResultsSuccess({ data }));
    } else {
      yield put(trainingResultsFailure(data?.message));
    }
  } catch (error) {
    yield put(trainingResultsFailure(error));
  }
}

function* analysisModelSelectionSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const { anid, ...payload } = action.payload;
    const response = yield call(analysisModelSelectionApi(anid), payload, headers);
    const {
      data: {
        result: { status, data },
      },
    } = response

    if (status === "Success") {
      yield put(analysisModelSelectionSuccess({ data }));
      yield put(selectedModelsRequest(anid));
    } else {
      yield put(analysisModelSelectionFailure(data?.message));
    }
  } catch (error) {
    yield put(analysisModelSelectionFailure(error));
  }
}

function* modelEvaluationSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const { anid, ...payload } = action.payload;
    const response = yield call(modelEvaluationApi(anid), payload, headers);
    const {
      data: {
        results,
        evaluation_id,
        message
      },
      status
    } = response
    const data = {...results, evaluation_id}

    if (status === 200) {
      yield put(modelEvaluationSuccess({ data }));
    } else {
      yield put(modelEvaluationFailure(message));
    }
  } catch (error) {
    yield put(modelEvaluationFailure(error));
  }
}

function* selectedModelsSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const anid = action.payload;
    const response = yield call(selectedModelsApi(anid), null, headers);
    const {
      data: {
        results: data,
        message
      },
      status
    } = response

    if (status === 200) {
      yield put(selectedModelsSuccess(data));
    } else {
      yield put(selectedModelsFailure(message));
    }
  } catch (error) {
    yield put(selectedModelsFailure(error));
  }
}

function* favoriteModelsSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const { anid, ...payload } = action.payload;
    const response = yield call(favoriteModelsApi(anid), payload, headers);
    const {
      data: {
        results: data,
        message
      },
      status
    } = response

    if (status === 200) {
      yield put(favoriteModelsSuccess(data));
    } else {
      yield put(favoriteModelsFailure(message));
    }
  } catch (error) {
    yield put(favoriteModelsFailure(error));
  } finally {
    const { anid } = action.payload;
    yield put(selectedModelsRequest(anid));
  }
}

export default function* rootSaga(): Generator<any, any, any> {
  yield takeLatest(operationConfigsRequest, operationConfigsSaga);
  yield takeLatest(operationListRequest, operationListSaga);
  yield takeLatest(operationCreateRequest, operationCreateSaga);
  yield takeLatest(operationDetailsRequest, operationDetailsSaga);
  yield takeLatest(analysisListRequest, analysisListSaga);
  yield takeLatest(analysisCreateRequest, analysisCreateSaga);
  yield takeLatest(analysisDatasetRequest, analysisDatasetSaga);
  yield takeLatest(analysisDetailsRequest, analysisDetailsSaga);
  yield takeLatest(analysisUpdateRequest, analysisUpdateSaga);
  yield takeLatest(dwtAnalysisRequest, dwtAnalysisSaga);
  yield takeLatest(dwtTransformRequest, dwtTransformSaga);
  yield takeLatest(operationDatasetAddRequest, operationDatasetAddSaga);
  yield takeLatest(trainingRequest, trainingSaga);
  yield takeLatest(trainingResultsRequest, trainingResultsSaga);
  yield takeLatest(analysisModelSelectionRequest, analysisModelSelectionSaga);
  yield takeLatest(modelEvaluationRequest, modelEvaluationSaga);
  yield takeLatest(selectedModelsRequest, selectedModelsSaga);
  yield takeLatest(favoriteModelsRequest, favoriteModelsSaga);
}